import { cn } from '@/lib/utils';

const PALETTE = ['bg-domino-lilac text-domino-aubergine', 'bg-[#fdf0da] text-[#8a5300]', 'bg-[#e8f5ec] text-[#1f7a43]', 'bg-[#fdecea] text-[#b42318]', 'bg-domino-muted text-domino-ink'];

const initials = (name: string) => name.split(/[\s-]+/).filter(Boolean).slice(0, 2).map((part) => part[0]!.toUpperCase()).join('') || '?';

const colorOf = (name: string) => PALETTE[[...name].reduce((sum, char) => sum + char.charCodeAt(0), 0) % PALETTE.length]!;

/** A person's initials in a colored circle; the name is in the title and for screen readers. */
export const Avatar = ({ name, size = 'sm', className }: { name: string; size?: 'xs' | 'sm'; className?: string }) => (
  <span title={name} className={cn('inline-flex shrink-0 items-center justify-center rounded-full font-semibold',
    size === 'xs' ? 'h-5 w-5 text-[9px]' : 'h-6 w-6 text-[10px]', colorOf(name), className)}>
    <span aria-hidden="true">{initials(name)}</span>
    <span className="sr-only">{name}</span>
  </span>
);
